module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(0);

  function o(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          o = !1,
          u = void 0;

      try {
        for (var i, c = e[Symbol.iterator](); !(n = (i = c.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, u = e;
      } finally {
        try {
          n || null == c.return || c.return();
        } finally {
          if (o) throw u;
        }
      }

      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return u(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return u(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function u(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  function i(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(Object(r), !0).forEach(function (t) {
        a(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function a(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function f() {
    return "undefined" != typeof window ? Math.max(window.document.documentElement.clientWidth, window.innerWidth || 0) : 0;
  }

  function l() {
    return "undefined" != typeof window ? Math.max(window.document.documentElement.clientHeight, window.innerHeight || 0) : 0;
  }

  var s = new Set(),
      p = new Map(),
      d = f(),
      b = l();

  function y() {
    d = f(), b = l(), s.forEach(function (e) {
      var t = {
        vpW: d,
        vpH: b
      };

      if (p.has(e)) {
        var r = p.get(e),
            n = r.hasher,
            o = r.prevHash,
            u = n(t);
        u != o && (e(c(c({}, t), {}, {
          hash: u
        })), p.set(e, {
          hasher: n,
          prevHash: u
        }));
      } else e(t);
    });
  }

  t.default = function (e) {
    var t = "function" == typeof e,
        r = o(Object(n.useState)(function () {
      return t ? e && e({
        vpW: d,
        vpH: b
      }) : {
        vpW: d,
        vpH: b
      };
    }), 2),
        u = r[0],
        i = r[1],
        c = Object(n.useRef)(void 0),
        a = Object(n.useCallback)(!e || t ? function (e) {
      return i(e);
    } : function (t) {
      c.current && clearTimeout(c.current), c.current = setTimeout(function () {
        return i(t);
      }, e);
    }, [e]);
    return Object(n.useLayoutEffect)(function () {
      return t && p.set(a, {
        hasher: e,
        prevHash: u.hash
      }), s.add(a), window && 1 == s.size && (window.addEventListener("resize", y), y()), function () {
        p.delete(a), s.delete(a), 0 == s.size && window.removeEventListener("resize", y);
      };
    }, [a]), Object(n.useMemo)(function () {
      return [u.vpW, u.vpH, t ? u.hash : y];
    }, [u, y]);
  };
}]);